import { IntersectionIcon } from 'morpheus-ui';
import { VariantProps } from 'tailwind-variants';
import { getDisciplineIcon } from '../../../utils/new_discipline';
import { Icon } from '../../atoms/Icon';
import { Typography } from '../../molecules/Typography';
import { Card, IconVariant, TextVariant } from './variants';

interface IIconCard extends VariantProps<typeof Card> {
  title: string;
  description: string;
  subjects: number;
  action?: () => void;
  isHoverable?: 'white';
  isReleased?: boolean;
  slug: string;
}

export default function IconCard({
  isHoverable = 'white',
  type,
  title,
  description,
  subjects,
  color,
  slug,
  action,
  isReleased,
}: IIconCard) {
  return (
    <div className={Card({ color })} onClick={() => isReleased ? action && action() : null}>
      {!isReleased && (
        <div className="w-full h-full absolute top-0 left-0 backdrop-grayscale bg-mono-color-lighter/40 rounded-md">
        </div>
      )}
      <Icon
        type='svg'
        Icon={getDisciplineIcon(slug) || IntersectionIcon}
        className={IconVariant({ color, type })}
      />
      <div className='flex justify-normal'>
        <Typography
          size='h3'
          type='title'
          className={`text-center md:line-clamp-2 ${TextVariant({ type: 'title', hover: isHoverable })}`}
        >
          {title}
        </Typography>
      </div>
      {!isReleased ? (
        <div className="w-full h-6 border-hairline border-mono-color-dark rounded-pill p-1">
          <div className="h-full w-[75%] flex items-center justify-center bg-mono-color-dark rounded-pill">
            <Typography size='mini' className='text-center text-mono-color-white'>
              Em breve
            </Typography>
          </div>
        </div>
      ) : (
        <div className='mt-auto'>
          <Typography
            className={TextVariant({ type: 'title', hover: isHoverable })}
          >
            {description}
          </Typography>
        </div>
      )}
      
      <Typography
        weight='bold'
        className={TextVariant({ type: 'paragraph', hover: isHoverable })}
      >
        {subjects} {subjects > 1 ? 'Assuntos' : 'Assunto'}
      </Typography>
    </div>
  );
}
